import React, { useRef, useEffect } from "react";
import rootStyles from "./styles/rootStyle";
import { AppStateContextProvider, useAppState } from "./context/appContex";
import { IMainProps } from "./@types/types";
import Main from "./container/Main";
import { InitialRender } from "./InitialRender";

const App: React.FC = () => {
  const {
    theme,
    menuData,
    isError,
    clientCode,
    accountLang,
    setIsGlobalSearchVisible,
    setIsCloseAppDropDownsFromApp,
  } = useAppState();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref && ref.current) {
      const element = ref.current;
      document.addEventListener("click", (e) => {
        if (!e.composedPath().includes(element)) {
          // close any open drop down if clicked outside of the component
          // element.isCloseComDropDown = true;
          setIsCloseAppDropDownsFromApp(true);
          // element.isGlobalSearchVisible = false;
          setIsGlobalSearchVisible(false);
        } else {
          setIsCloseAppDropDownsFromApp(false);
          // element.isCloseComDropDown = false;
        }
      });
      // close global search when a this event is fired from the component

      // console.log("new-user-menu is mounted on the DOM");
    }
  }, [ref, setIsGlobalSearchVisible, setIsCloseAppDropDownsFromApp]);

  return (
    <div ref={ref}>
      <style>{rootStyles}</style>
      <div data-theme={theme}>
        {menuData ? <Main /> : null}
        {isError || !menuData || !accountLang || !clientCode ? (
          <InitialRender />
        ) : null}
        {/* <button
          onClick={switchTheme}
          style={{ margin: "10px", padding: "10px" }}
        >
          Switch to {theme === "light" ? "Dark" : "Light"} Theme
        </button> */}
      </div>
    </div>
  );
};

const MainApp: React.FC<IMainProps> = ({ ...props }) => {
  return (
    <AppStateContextProvider {...props}>
      <App />
    </AppStateContextProvider>
  );
};

MainApp.defaultProps = {
  clientCode: "104180",
  accountLang: "eng",
  user: "Prince Test",
  sessionKey: "10a0b4dceb3711efff95d838ef0488dc068cdd639555",
  // newMenuItem: null,
  // isCloseComDropDown: false,
  // isGlobalSearchVisible: false,
};

export default MainApp;
